var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"options":_vm.groupOptions,"value":_vm.selectedValue,"reduce":o => o.v,"label":"t"},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }